export default abstract class BaseController {
    element: HTMLElement;
    data: any;

    private unbinds: Function[] = []

    constructor(element, data) {
        this.element = element;
        this.data = data;
    }

    protected get urlBase(): string {
        return window["__UrlBase"] ?? '';
    }

    set sink(callback: Function) {
        this.unbinds.push(callback);
    }

    abstract init(): Promise<void>;
    destroy(): Promise<void> {
        this.unbinds.forEach(unbind => unbind());
        return Promise.resolve();
    }
}